import { Component, OnInit  } from '@angular/core';
import { MenuService } from '../menu.service';

declare var jQuery: any;
declare var paceLoad: any;
declare var owlSlider: any;

@Component({
  selector: 'app-showroom',
  templateUrl: './showroom.component.html',
  styleUrls: ['./showroom.component.css']
})
export class ShowroomComponent implements OnInit  {

  constructor(public menuCtrl: MenuService) { }

  ngOnInit() {
    // paceLoad();
    owlSlider();
    let el = document.getElementById("nav-toggle");
    let nav = document.getElementById("nav__content");
    let inNav = document.getElementById("sectores-items");
    let sect = document.getElementById("sector");
    let subStatus = false;
    
    sect.onclick = function() {
      subStatus = !subStatus;
      myFunction();
    };

    function myFunction() {
      if (subStatus == true ){
        inNav.style.height = "150px";
      }else{
        inNav.style.height = "0px";
      }

  }
  }
}